export default __webpack_public_path__ + "static/media/baseball-player-faded.1c52c29d.png";